import { surfaceColorAt } from "./surface.js";

export function followSurfaceColor(): void {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (!(meta instanceof HTMLMetaElement)) {
    return;
  }
  let queued = false;
  const update = () => {
    queued = false;
    const colour = surfaceColorAt(Math.round(window.innerWidth / 2), 1);
    if (colour !== null && colour !== meta.content) {
      meta.content = colour;
    }
  };
  const schedule = () => {
    if (!queued) {
      queued = true;
      requestAnimationFrame(update);
    }
  };
  update();
  window.addEventListener("scroll", schedule, { passive: true });
  window.addEventListener("resize", schedule, { passive: true });
}
